import React, { useState } from 'react';
import ComplianceSection from './ComplianceSection';
import { IDriverSummary } from '../../type/driverSummary';
import { formatDateToDDMMYYYY, getAdjustedDate } from '../../utils/dateUtils';
import { COMPLIANCE_STATUS } from '../../constants/constant';

type Props = {
  data: IDriverSummary[];
  driverAccordionIsOpen?: boolean;
};

export type Staff = {
  name: string;
  staffId: number;
  contactStaffId: number;
};
const DriverSummarySection: React.FC<Props> = ({
  data,
  driverAccordionIsOpen,
}) => {
  const [isEditMode, setEditMode] = useState(false);
  const [updatedAllocations, setUpdatedAllocations] = useState<{
    [key: number]: number;
  }>({});
  const [isEdit] = useState<boolean>(true);
  
  // Transform data into headers/rows format

  const aircraftRows = data?.map((item, index) => {
    const statusColor =
      item.compliantStyle ==COMPLIANCE_STATUS.expired
        ? 'text-yellow-700'
        : item.compliantStyle==COMPLIANCE_STATUS.upcoming||item?.compliantStyle==COMPLIANCE_STATUS.current
          ? 'text-yellow-500'
          : 'text-gray-700';
    return [
      item?.staffName,
      <td
      className={` ${
      item?.restStyle === COMPLIANCE_STATUS.expired
      ? 'text-red-700'
      : item?.restStyle === COMPLIANCE_STATUS.upcoming || item?.restStyle === COMPLIANCE_STATUS.current
        ? 'text-yellow-500'
        :item?.restStyle ||item?.restStyle ==COMPLIANCE_STATUS.compliant? 'text-green'
        : 'text-gray-700'
        }`}
      >
      {item?.restDays}/{item?.minRestDays}
      </td>
    ,
      <td 
      className={` ${
      item?.consecRestStyle === COMPLIANCE_STATUS.expired
      ? 'text-red-700'
      : item?.consecRestStyle === COMPLIANCE_STATUS.upcoming || item?.consecRestStyle === COMPLIANCE_STATUS.current
        ? 'text-yellow-500'
        :item?.consecRestStyle =='' ||item?.restStyle ==COMPLIANCE_STATUS.compliant ? 'text-green'
        : 'text-gray-700'
        }`}
      >
        {item?.consecRestDays}/{item?.minConsecRestDays}
      </td>
      ,
      <td 
       className={` ${
      item?.workStyle === COMPLIANCE_STATUS.expired
      ? 'text-red-700'
      : item?.workStyle === COMPLIANCE_STATUS.upcoming || item?.workStyle === COMPLIANCE_STATUS.current
        ? 'text-yellow-500'
        :item?.workStyle ==''|| item?.restStyle ==COMPLIANCE_STATUS.compliant? 'text-green'
        : 'text-gray-700'
      }`}
      >
      {item?.workDays}/{item?.maxWorkDays}
      </td>,
      <td 
      className={` ${
      item?.consecWorkStyle === COMPLIANCE_STATUS.expired
      ? 'text-red-700'
      : item?.consecWorkStyle === COMPLIANCE_STATUS.upcoming || item?.consecWorkStyle === COMPLIANCE_STATUS.current
        ? 'text-yellow-500'
        :item?.compliantStyle =='' || item?.restStyle ==COMPLIANCE_STATUS.compliant? 'text-green'
        : 'text-gray-700'
      }`}
      >
        {item?.consecWorkDays}/{item?.maxConsecWorkDays}
      </td>,
      item?.kkd == true ? 'Y' : '',
    ];
  });
  const dateTime = formatDateToDDMMYYYY(getAdjustedDate());
  const aircraftHeaders = [
    { label: 'Driver Summary ' },
    { label: 'Rests Days in 14 Total(Min 4)' },
    { label: 'Consec. (Min2) ' },
    { label: "KK'D Days In 14 Total(Max 10)" },
    { label: 'Consec. (Max6)' },
    { label: `KK'D ${dateTime}` },
  ];

  //TODO: I will update this any to right type


  const handleEdit = () => setEditMode(true);
  const handleCancel = () => setEditMode(false);
  const handleSave = () => {
    // Save logic here
    setEditMode(false);
  };

  return (
    <>
      <div className="ml-6 mr-4">
        <ComplianceSection
          title={`Driver Summary ${dateTime}`}
          headers={aircraftHeaders}
          rows={aircraftRows}
          updatedAllocations={updatedAllocations}
          isEditMode={isEditMode}
          isEdit={isEdit}
          onEditClick={handleEdit}
          onCancel={handleCancel}
          onSave={handleSave}
          driverAccordionIsOpen={driverAccordionIsOpen}
        />
      </div>
    </>
  );
};

export default DriverSummarySection;
